import { render } from "./MisDatos.vue?vue&type=template&id=70f7f296&ts=true"
import script from "./MisDatos.vue?vue&type=script&lang=ts"
export * from "./MisDatos.vue?vue&type=script&lang=ts"

import "./MisDatos.vue?vue&type=style&index=0&id=70f7f296&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__